import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import {
  AppBarComponent,
  AppBarCloseAction,
  AppBarTitleComponent,
  AppPageComponent,
  AppFooterComponent,
} from "common";
import { BrokerCurrentResolver } from "../broker/infrastructure/broker.resolver";
import { WebPaths } from "../shared/SharedConstants";
import { UpdatePasswordComponent } from "./update-password.component";

const routes: Routes = [
  {
    path: WebPaths.UpdatePassword.slice(1),
    title: "Update Password – Idea Financial Partner",
    component: AppPageComponent,
    data: {
      appPage: {
        contentClass: "simple",
        contentAlignment: "center-start",
        contentWithoutPadding: false,
      },
      appBar: {
        stickyDisabled: true,
        closeAction: AppBarCloseAction.BACK,
        logoHidden: true,
        containerClass: "start-center",
      },
      appBarTitle: {
        content: "Update Password",
      },
    },
    resolve: {
      brokerUser: BrokerCurrentResolver,
    },
    children: [
      {
        path: "",
        outlet: "app-bar",
        component: AppBarComponent,
        children: [
          {
            path: "",
            outlet: "title",
            component: AppBarTitleComponent,
          },
        ],
      },
      {
        path: "",
        component: UpdatePasswordComponent,
      },
      {
        path: "",
        outlet: "app-footer",
        component: AppFooterComponent,
        data: {
          appFooter: {
            full: true,
          },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class UpdatePasswordRoutingModule {}
